module.exports = __webpack_public_path__ + "static/img/pay_succ_joychat.b0fde245.webp";